module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-818.0cd6f729.jpg";